import {fetchApi} from "@mbj-front-monorepo/data-access";
import {useQuery} from "@tanstack/react-query";


export const useGetAllStatutResultsSearch = ()=>{
  const promise = () => fetchApi("/api/statut_results_searches", { method: "get"});
  return useQuery<Awaited<ReturnType<typeof promise>>, Error>(["statut_r_s"], promise, );
}
